import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

import { TakeawayOrderFailed } from "../components/TakeawayOrderFailed"

type Props = Readonly<{
    isPublic?: boolean
}>

export function TakeawayPaymentCanceled({ isPublic = false }: Props) {
    return (
        <LocalizedStrict id="takeaway-payment-canceled" attrs={{ title: true, description: true }}>
            <TakeawayOrderFailed
                title="Purchase canceled"
                description="You canceled the payment of your order."
                isPublic={isPublic}
            />
        </LocalizedStrict>
    )
}
